import './App.css';
import React from 'react';
import Home from './Home';
import { Routes, Route } from 'react-router-dom';
import RepoConfig from './RepoConfig';
import OrganizationManager from './components/OrganizationManager';
import VersionUpdater from './components/VersionUpdater';
import AcceptInvitation from './pages/AcceptInvitation';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/config/:owner/:repo" element={<RepoConfig />} />
      <Route path="/organizations" element={<OrganizationManager />} />
      <Route path="/update-versions" element={<VersionUpdater />} />
      <Route path="/accept-invitation" element={<AcceptInvitation />} />
    </Routes>
  );
}

export default App;
